import bbox from '@turf/bbox';
import { FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import { LngLat, LngLatBoundsLike } from 'mapbox-gl';

/**
 * Calculate and validate bounding box around a given feature collection
 *
 * @param {FeatureCollection<Geometry, GeoJsonProperties>} featureCollection The features
 * to include inside the bounds
 *
 * @returns {LngLatBoundsLike} The bounding box corners as lnglat coordinates,
 * or null if it was unable to be calculated
 *
 */
export const getBoundsFromFeatureCollection = (
  featureCollection: FeatureCollection<Geometry, GeoJsonProperties>
): LngLatBoundsLike | null => {
  if (!featureCollection.features?.length) {
    return null;
  }
  const bbox3d = bbox(featureCollection);
  // Check if coordinates are numbers
  if (
    typeof bbox3d[0] !== 'number' ||
    typeof bbox3d[1] !== 'number' ||
    typeof bbox3d[2] !== 'number' ||
    typeof bbox3d[3] !== 'number'
  ) {
    return null;
  }

  const corner1 = new LngLat(bbox3d[0], bbox3d[1]);
  const corner2 = new LngLat(bbox3d[2], bbox3d[3]);
  return [
    [corner1.lng, corner1.lat],
    [corner2.lng, corner2.lat],
  ];
};
